import { render, staticRenderFns } from "./personManage.vue?vue&type=template&id=ceeaed1a&"
import script from "./personManage.vue?vue&type=script&lang=js&"
export * from "./personManage.vue?vue&type=script&lang=js&"
import style0 from "./personManage.vue?vue&type=style&index=0&id=ceeaed1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports